import { Entry } from '../Entry'

export function Entry20231116() {
  return (
    <Entry title="Nov 16 2023 - v3.5.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15585/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
